/*
 * <cart-discount> — remove an applied discount code from the cart drawer.
 * Clicking a chip's × sends the remaining codes to POST /cart/update.js
 * (Shopify replaces the cart's code set; "" clears all), then re-renders the
 * drawer via the theme's existing cart machinery.
 */
if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-discount-remove]').forEach((btn) =>
          btn.addEventListener('click', () => this.remove(btn.dataset.discountCode, btn))
        );
      }

      /* Codes currently applied (from the rendered chips). */
      currentCodes() {
        return Array.from(this.querySelectorAll('[data-discount-remove]')).map(
          (b) => b.dataset.discountCode
        );
      }

      remove(code, btn) {
        if (btn.classList.contains('loading')) return;
        btn.classList.add('loading');

        const remaining = this.currentCodes().filter(
          (c) => c.toLowerCase() !== (code || '').toLowerCase()
        );

        const cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        const config = fetchConfig('javascript');
        const body = { discount: remaining.join(',') };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((s) => s.id).join(',');
          body.sections_url = window.location.pathname;
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);

        fetch(`${routes.cart_update_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount' });
            }
            if (cart && cart.renderContents) {
              cart.renderContents(response);
            } else {
              window.location.reload();
            }
          })
          .catch((e) => {
            console.error('cart-discount remove error:', e);
            btn.classList.remove('loading');
          });
      }
    }
  );
}
